import { SchemaService } from "@/shared/services/SchemaService";
import { AnalysisConfigSchema } from "../models/AnalysisConfigSchema";
import { AnalysisConfigService } from "./AnalysisConfigService";

export class AnalysisConfigSchemaService extends SchemaService<AnalysisConfigSchema> {

    static readonly injectableKey = 'AnalysisConfigSchemaService';

    get injectableKey() {
        return (this.constructor as typeof AnalysisConfigSchemaService).injectableKey;
    }

    public cdnContentPath: string = "analysis_config/analysis_config_schemas";

    public getInternalSchemas(): Array<AnalysisConfigSchema> {
        const internalSchemas = [
            {
                type: `${AnalysisConfigService.CUSTOM_ANALYSISCONFIG_TYPE}`,
                display_name: "Unknown AnalysisConfig",
                description: "Add unknown analysis configuration",
                category: "Custom",
                is_visible: false,
                fields: [
                    {
                        name: "value",
                        display_name: "Json",
                        field_type: "json",
                        required: true,
                        description: "Json Value"
                    }
                ],
                examples: [
                    {
                        type: "json"
                    }
                ]
            }
        ] as Array<AnalysisConfigSchema>;

        return internalSchemas;
    }

}
